module.exports = __webpack_public_path__ + "static/media/preview5.81633b0f.png";